import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Row } from "react-bootstrap";
import InputForm from "../../components/inputs/InputForm";
import { Loader, toaster } from "rsuite";
import CardC from "../../components/CustomCard/CardC";
import peticionBack from "../../libs/peticiones/peticionBack";
import { useState } from "react";
import { authConstants } from "../../context/constants";
import { useStore } from "../../context/AppContext";

const defaultForm: { username: string; password: string } = {
	username: "",
	password: "",
};

const formSchema = Yup.object().shape({
	username: Yup.string().required("Ingrese un nombre de usuario"),
	password: Yup.string().required("Ingrese una contraseña"),
});

export default function Login() {
	const [loading, setLoading] = useState<boolean>(false);
	const { dispatch } = useStore();

	const {
		handleSubmit,
		handleBlur,
		setFieldValue,
		values,
		errors,
		touched
	} = useFormik({
		initialValues: defaultForm,
		validationSchema: formSchema,
		onSubmit: (values) => singin(),
		onReset: () => { },
	});

	function onChange({ target }: { target: any }) {
		setFieldValue(target.name, target.value);
	}
	
	async function singin() {
		setLoading(true);
		dispatch({ type: authConstants.LOGIN_REQUEST });
		const res = await peticionBack(values, '/auth/login', 'POST', false, toaster);
		if (res) {
			const data = res;
			const perfiles = data.login.profiles.map((el: any) => {return { _id: el._id, name: el.name } });
			dispatch({
				type: authConstants.LOGIN_SUCCESS,
				payload: {
					credentials: {
						_id: data.login._id,
						token: data.token,
						fullname: data.login.fullname,
					},
					perfiles: perfiles,
					currentperfil: perfiles[0] || null,
				}
			});
		} else {
			dispatch({ type: authConstants.LOGIN_FAILURE, payload: { error: "ERROR" } });
		}
		setLoading(false);
	}

	return (
		<Row className="flex-fill justify-content-center m-md-5 m-sm-3 m-0">
			<Col xs={12} md={8} lg={5}>
				<CardC>
					<div className="container text-center mb-4">
						<h3>Iniciar Sesión</h3>
					</div>
					<form onSubmit={handleSubmit}>
						<InputForm
							label="Usuario"
							name="username"
							type="text"
							value={values.username}
							touched={touched.username}
							error={errors.username}
							onChangeMethod={onChange}
							onBlurMethod={handleBlur}
							required
						/>
						<InputForm
							label="Contraseña"
							name="password"
							type="password"
							value={values.password}
							touched={touched.password}
							error={errors.password}
							onChangeMethod={onChange}
							onBlurMethod={handleBlur}
							required
						/>
						<div className="mt-4 container text-center mb-2">
							<Button variant="success" type="submit">
								Ingresar
							</Button>
						</div>
					</form>
					{ loading && <Loader backdrop style={{zIndex: "2"}} size="md" /> }
				</CardC>
			</Col>
		</Row>
	);
}
